/**
 * Форматирует число для отображения: K для тысяч, M для миллионов.
 * @param {number|string} num
 * @returns {string}
 */
export const formatNumber = (num) => {
    if (!num && num !== 0) return '-';
    
    const number = typeof num === 'string' ? parseInt(num, 10) : num;
    
    if (number >= 1000000) {
        const millions = number / 1000000;
        return millions % 1 === 0 
            ? `${millions}M` 
            : `${millions.toFixed(1)}M`;
    } else if (number >= 1000) {
        const thousands = number / 1000;
        return thousands % 1 === 0 
            ? `${thousands}K` 
            : `${thousands.toFixed(1)}K`;
    }
    
    return number.toLocaleString();
};
